// extracted by mini-css-extract-plugin
export default {"navFooter":"NavFooter_navFooter__RaeyJ"};